import React from 'react';
import { useLocation } from 'react-router-dom';

const PdfViewer = () => {
  const location = useLocation();
  const { fileUrl } = location.state;

  return (
    <div>
      <h1>PDF Viewer</h1>
      {fileUrl ? (
        <iframe src={fileUrl} width="100%" height="600px"></iframe>
      ) : (
        <p>No file to display</p>
      )}
    </div>
  );
};

export default PdfViewer;
